import React from "react";
import StyledFooter from "../style/StyledFooter";

const Footer = () => {
  return (
    <StyledFooter>
      <small>&copy; 2022 Yunikstarz. All Rights Reserved.</small>
    </StyledFooter>
  );
};

export default Footer;
